import {
    toggleTask, deleteTask,
    toggleHabit, deleteHabit,
    toggleReminder, deleteReminder,
    toggleListItem, deleteListItem,
} from "@/lib/api";
import { undoableDelete } from "@/lib/undoDelete";
import { celebrateWin } from "@/lib/wins";

// Row handlers for global-search results — toggling/deleting an item of any
// kind directly from the search result list (with undo support on delete).
export function useSearchRowHandlers({ search, refreshStats }) {
    const handleSearchToggle = async (r) => {
        try {
            let res;
            if (r.kind === "task") res = await toggleTask(r.id, !r.completed);
            else if (r.kind === "habit") res = await toggleHabit(r.id);
            else if (r.kind === "reminder") await toggleReminder(r.id, !r.completed);
            else if (r.kind === "list_item") await toggleListItem(r.id, !r.completed);
            if (res?.win) celebrateWin(res.win);
        } catch (e) {
            console.warn("search row toggle failed", e);
        }
        await Promise.all([refreshStats(), search.refetch()]);
    };

    const handleSearchDelete = (r) => {
        const apiCall = r.kind === "task" ? deleteTask
            : r.kind === "habit" ? deleteHabit
            : r.kind === "reminder" ? deleteReminder
            : deleteListItem;
        const label = r.kind === "list_item" ? "Item"
            : r.kind.charAt(0).toUpperCase() + r.kind.slice(1);
        undoableDelete({
            label,
            item: r,
            apiDelete: apiCall,
            onLocalRemove: () => search.setResults((p) => p.filter((x) => x.id !== r.id)),
            onLocalRestore: () => search.setResults((p) => (p.some((x) => x.id === r.id) ? p : [...p, r])),
            onCommit: async () => { await refreshStats(); await search.refetch(); },
        });
        refreshStats();
    };

    return { handleSearchToggle, handleSearchDelete };
}
